export const errorMessages = {
  'Network Error': 'Check your internet connection',
}
